import styled from 'styled-components'

export const P = styled.p`
  color: ${props => props.theme};
`

export const Container = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-bottom: none;
`

export const Option = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  text-transform: uppercase;
  & > svg {
    width: 30px;
    height: 30px;
    padding-top: 5px;
  }
  &:hover {
    background-color: rgba(192, 192, 192, 0.3);
  }
`



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/OptionsButtons/styles/option.js